export default __webpack_public_path__ + "static/media/face1.705685f1.jpg";